import { render, staticRenderFns } from "./PartnerRewardsList.vue?vue&type=template&id=9d78f4e4&scoped=true&"
import script from "./PartnerRewardsList.vue?vue&type=script&lang=js&"
export * from "./PartnerRewardsList.vue?vue&type=script&lang=js&"
import style0 from "./PartnerRewardsList.vue?vue&type=style&index=0&id=9d78f4e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d78f4e4",
  null
  
)

export default component.exports